<!-- Toolbar -->
<td-wb-toolbar>
  <td-wb-toolbar-item-help articleId="lti_manage_goals" />
</td-wb-toolbar>
<td-wb-sticky-panel-top>
  <td-wb-page-header position="center"
                     class="td-wb-learn-welcome__header">
    <td-wb-page-header-title id="td-wb-aria-lti-dashboard-main-header"
                             translate="tdWb.lti.dashboard.MANAGE_GOALS" />
    <td-wb-page-header-toolbar>
      <td-wb-mobile-toolbar>
        <td-wb-toolbar-item-help articleId="lti_manage_goals" />
      </td-wb-mobile-toolbar>
    </td-wb-page-header-toolbar>
  </td-wb-page-header>
</td-wb-sticky-panel-top>
<td-wb-page-panel role="region"
                  aria-labelledby="td-wb-aria-lti-dashboard-main-header">
  <td-wb-lti-page-panel class="td-wb-dashboard">
    <div class="td-wb-dashboard__header"
          [class.td-wb-dashboard__header--no-name]="switchGiem">
      @if (!switchGiem) {
        <h2 class="td-wb-dashboard__welcome"
            translate="tdWb.lti.dashboard.WELCOME"
            [translateParams]="{name: clientName}"></h2>
      }
      @if (showAddGoalButton()) {
        <button tdWbButton
                tdWbButtonType="secondary"
                tdWbBlock="spinningWheel"
                id="td-wb-lti-dashboard-add-goal"
                [disabled]="disableAddGoal"
                (click)="onAddGoalClick()">
          <span translate="tdWb.lti.dashboard.ADD_GOAL"></span>
        </button>
      }
    </div>

    @if (hasGoals()) {
      <div class="td-wb-dashboard__goals">
        @for (goal of displayedGoals; track goal;) {
          <div class="td-wb-dashboard__goal" role="region"
               [attr.aria-labelledby]="'td-wb-aria-lti-dashboard-goal-' + goal.id">
            <td-wb-lti-dashboard-goal [goal]="goal"
                                      [smallView]="smallView" />
          </div>
        }
        @if (showPagination()) {
          <td-wb-pagination class="td-wb-dashboard__pagination"
                            [itemCount]="goals().length"
                            [itemsPerPage]="goalsDisplayedPerPage"
                            (selectedPageChange)="onPageClick($event)" />
        }
      </div>
    }

    @if (!showAddGoalButton()) {
      <div>
        <td-wb-call-out [size]="smallView || mediumView ? 'small' : 'large'"
                        [layout]="smallView ? 'column' : 'row'">
          <div tdWbCallOutIcon class="td-wb-dashboard__single-goal-icon">
            <td-wb-icon iconId="lti-dashboard--create-a-goal"
                        iconType="secondary"
                        size="60" />
          </div>
          <div class="td-wb-dashboard__single-goal">
            <div class="td-wb-dashboard__single-goal-header"
                 translate="tdWb.lti.dashboard.HAVE_OTHER_GOALS"></div>
            <div translate="tdWb.lti.dashboard.CREATE_A_GOAL"></div>
          </div>
          <div tdWbCallOutButton
               class="td-wb-dashboard__single-goal-buttons">
            <button class="td-wb-dashboard__single-goal-button"
                    tdWbButton
                    tdWbButtonType="secondary"
                    (click)="onAddGoalClick()">
              <span translate="tdWb.lti.dashboard.CREATE_ANOTHER_GOAL"></span>
            </button>
          </div>
        </td-wb-call-out>
      </div>
    }

    <td-wb-dashboard-as-start-page-callout [size]="smallView || mediumView ? 'small' : 'large'"
                                           [layout]="smallView ? 'column' : 'row'" />

    <div class="td-wb-dashboard__education">
      <h2 class="td-wb-dashboard__education-content-header"
          translate="tdWb.lti.dashboard.educationNews.HEADER"></h2>
      <div class="td-wb-dashboard__education-container">
        @if (showAllEducationCards()) {
          <td-wb-card class="td-wb-dashboard__education-container-inner">
            <td-wb-image-placeholder aspectRatio="16:9"
                                     class="td-wb-dashboard__education-investing">
              <img alt=""
                   class="td-wb-dashboard__education-investing-icon"
                   [src]="'assets/core/illustrations/' + ('tdWb.lti.dashboard.educationNews.ICONS'| translate) + '.svg'"
                   width="100%"/>
            </td-wb-image-placeholder>
            <td-wb-card-content>
              <div class="td-wb-dashboard__education-content">
                <span class="td-wb-dashboard__education-label"
                      translate="tdWb.lti.dashboard.educationNews.INVESTING"></span>
                <h3 id="td-wb-aria-money-talk-header"
                    class="td-wb-dashboard__education-header"
                    translate="tdWb.lti.dashboard.educationNews.MONEY_TALK">
                </h3>
                <a class="td-wb-dashboard__education-link"
                   aria-labelledby="td-wb-aria-learn-more td-wb-aria-money-talk-header"
                   tdWbHref="link_lti_dashboard_money_talk"
                   target="_blank"
                   rel="noopener">
                  <span id="td-wb-aria-learn-more"
                        translate="tdWb.lti.dashboard.educationNews.LEARN_MORE"></span>
                  <td-wb-icon class="td-wb-dashboard__education-link-icon"
                              iconId="caret-right--small"
                              [inline]="true" />
                </a>
              </div>
            </td-wb-card-content>
          </td-wb-card>
        }
        @if (showAllEducationCards()) {
          <td-wb-card class="td-wb-dashboard__education-container-inner"
                      size="large"
                      layout="column">
            <td-wb-image-placeholder aria-hidden="true"
                                     aspectRatio="16:9"
                                     class="td-wb-dashboard__education-investing">
              <img alt=""
                   src="assets/images/lti-dashboard--education.png"
                   class="td-wb-dashboard__image">
            </td-wb-image-placeholder>
            <td-wb-card-content>
              <div class="td-wb-dashboard__education-content">
                <span class="td-wb-dashboard__education-label"
                      translate="tdWb.lti.dashboard.educationNews.EDUCATION"></span>
                <h3 id="td-wb-aria-education-achieve-header"
                    class="td-wb-dashboard__education-header"
                    translate="tdWb.lti.dashboard.educationNews.ACHIEVE_YOUR_GOAL">
                </h3>
                <a class="td-wb-dashboard__education-link"
                   tdWbHref="link_learn"
                   aria-labelledby="td-wb-aria-education-achieve-header">
                  <span translate="tdWb.lti.dashboard.educationNews.LEARN_MORE"></span>
                  <td-wb-icon class="td-wb-dashboard__education-link-icon"
                              iconId="caret-right--small"
                              [inline]="true" />
                </a>
              </div>
            </td-wb-card-content>
          </td-wb-card>
        }
        <td-wb-card class="td-wb-dashboard__education-container-inner"
                    size="large"
                    layout="column">
          <td-wb-image-placeholder aria-hidden="true"
                                   aspectRatio="16:9"
                                   class="td-wb-dashboard__education-investing">
            <img alt=""
                 src="assets/images/lti-dashboard--faq.png"
                 class="td-wb-dashboard__image">
          </td-wb-image-placeholder>
          <td-wb-card-content>
            <div class="td-wb-dashboard__education-content">
              <span class="td-wb-dashboard__education-label"
                    translate="tdWb.lti.dashboard.educationNews.FAQ"></span>
              <h3 class="td-wb-dashboard__education-header"
                  translate="tdWb.lti.dashboard.educationNews.QUESTIONS">
              </h3>
              <a class="td-wb-dashboard__education-link"
                 tdWbHref="link_lti_dashboard_faq"
                 target="_blank"
                 rel="noopener">
                <span translate="tdWb.lti.dashboard.educationNews.BROWSE_THE_FAQS"></span>
                <td-wb-icon class="td-wb-dashboard__education-link-icon"
                            iconId="caret-right--small"
                            [inline]="true" />
              </a>
            </div>
          </td-wb-card-content>
        </td-wb-card>
      </div>
    </div>
    <ng-template #addGoalMessage>
      <td-wb-confirm>
        <td-wb-confirm-title [translate]="'tdWb.lti.dashboard.' + addGoalMessageHeader" />
        <td-wb-confirm-body>
          <div class="td-wb-dashboard__confirm-body-text"
               translate="tdWb.lti.dashboard.NO_ACCOUNTS_BODY_I"></div>
          <div translate="tdWb.lti.dashboard.NO_ACCOUNTS_BODY_II"></div>
        </td-wb-confirm-body>
        <td-wb-confirm-buttons>
          <td-wb-confirm-button>
            <span translate="tdWb.lti.dashboard.NO_THANKS"></span>
          </td-wb-confirm-button>
          <button class="td-wb-dashboard__confirm-button"
                  tdWbButton
                  tdWbButtonType="marketing"
                  tdWbHref="link_open_new_account"
                  tdWbModalClose>
            <td-wb-icon iconId="lock"
                        size="18"
                        [inline]="true" />
            <span translate="tdWb.lti.dashboard.OPEN_AN_ACCOUNT"></span>
          </button>
        </td-wb-confirm-buttons>
      </td-wb-confirm>
    </ng-template>
  </td-wb-lti-page-panel>
</td-wb-page-panel>

